/**
 * Verify that url is hosted on Shopify
 */
const urlIsHostedOnShopify = (url) => {
  return url.includes('https://cdn.shopify.com')
}

/**
 * Detect if a query string exists. Helpful for adding query arguments for imgix
 * because if "?" already exists, it needs to start with "&"
 */
export const queryStringAlreadyExists = (url) => {
  if (/[?&]q=/.test(url)) return true
  return false
}

/**
 * Generate placeholder image url
 */
const generateFakeImage = (image, width, height) => {
  return `https://fakeimg.pl/${width ? width : '500'}x${
    height ? height : '500'
  }/?retina=1&text=かろうし&font=noto&font_size=18`
}

/**
 * If height doesn't exist, but aspectRatio does, calculate height from apsectRatio
 */
export const calculateHeightFromAspectRatio = (width, height, aspectRatio) => {
  if (height) return height
  if (aspectRatio) {
    return width * aspectRatio
  }
  return 'auto'
}

/**
 * Allow the use of Material UI breakpoint functions
 *
 * Example:
 *
 * Normally sizes={`${theme.breakpoints.down('md')} 100vw, 500px`} would become
 * `sizes="@media (max-width:1127.95px) 100vw, 500px"`
 *
 * However wrapper in this function it becomes
 * `sizes="(max-width:1127.95px) 100vw, 500px"`
 */
export const formatSizes = (muiMq) => {
  return muiMq.replace('@media ', '')
}

const determineDataSource = (image) => {
  // console.log('👾 Image > getDataSource', image)
  if (typeof image.gatsbyImageData !== 'undefined') {
    return image.gatsbyImageData
  }
  if (typeof image.imgixImage !== 'undefined') {
    return image.imgixImage.gatsbyImageData
  }
  if (typeof image.localFile !== 'undefined') {
    return image.localFile.childImageSharp.gatsbyImageData
  }
  if (typeof image.imgixImage === 'undefined' && typeof image.localFile === 'undefined') {
    return image
  }
  throw new Error('Image object does not contain gatsbyImageData')
}

export const getImgSrc = (src, image, width, height) => {
  if (
    (typeof src === 'undefined' || src === null) &&
    (typeof image === 'undefined' || image === null)
  )
    return generateFakeImage(image, width, height)
  if (image) {
    return determineDataSource(image)
  }
  if (src) {
    return src
  }
  throw new Error('image or src is required in Image component')
}

export const chooseImageComponent = (source, img = false) => {
  if (img === true) return 'standard'
  if (typeof source !== 'string') return 'gatsbyImage'
  if (typeof source === 'string' && urlIsHostedOnShopify(source)) return 'imgix'
  return 'standard'
}
